/**
 * Audit log walkthrough — personal and admin audit views share one nav item.
 * @module features/walkthrough/tours/auditLogTour
 */

import { isAdmin } from '../../../utils/userAccess';
import { resolveAuditLogPath } from '../../../navigation/navConfig';
import { t, tourMeta } from '../i18n/walkthroughI18n';
import { navStep } from './navTourHelpers';

const meta = tourMeta('audit-log');

/** @type {import('../walkthroughTypes').WalkthroughTourDef} */
export const AUDIT_LOG_TOUR = {
  id: 'audit-log',
  title: meta.title,
  description: meta.description,
  roles: ['employee', 'pm', 'rm', 'csg', 'admin', 'dh'],
  prerequisiteRoute: '/account/audit-log',
  priority: 50,
  version: 2,
  visible: (user) => !!user,
  steps: [
    {
      ...navStep('my-audit-log', {
        title: t('walkthrough.audit.nav.title'),
        body: t('walkthrough.audit.nav.body'),
      }),
      id: 'audit-log-nav',
    },
    {
      id: 'audit-log-admin-scope',
      navItemId: 'my-audit-log',
      targetSelector: '[data-walkthrough="audit-log-admin-scope"]',
      title: t('walkthrough.audit.adminScope.title'),
      body: t('walkthrough.audit.adminScope.body'),
      placement: 'bottom',
      visible: (user) => isAdmin(user),
    },
  ],
};

/** Resolve prerequisite route per user (admin vs personal path). */
export function resolveAuditLogPrerequisiteRoute(user) {
  return resolveAuditLogPath(user);
}
